/** `snippets/product-card.liquid` — region-based availability badges on product cards. */

const REGION_LS_KEY = 'wyld_us_state'
const CARD_SELECTOR = '[data-product-card]'
const REGION_PROMPT_SELECTOR = '[data-product-card-region-prompt]'
const ADD_BTN_SELECTOR = '[data-product-card-add]'
const REGION_UNAVAILABLE_CLASS = 'product-card-region-unavailable'

function parseJsonAttr(el, attr) {
  const raw = el.getAttribute(attr)
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function isAvailableInState(includedStates, state) {
  if (includedStates.length === 0) return true
  return includedStates.includes(state)
}

function isSoldOut(addBtn) {
  return addBtn?.dataset.available === 'false'
}

function applyCardAvailability(card, state) {
  const prompt = card.querySelector(REGION_PROMPT_SELECTOR)
  const addBtn = card.querySelector(ADD_BTN_SELECTOR)

  if (!state) {
    if (prompt) prompt.hidden = false
    card.classList.remove(REGION_UNAVAILABLE_CLASS)
    if (addBtn) addBtn.disabled = isSoldOut(addBtn)
    return
  }

  if (prompt) prompt.hidden = true

  const included = parseJsonAttr(card, 'data-included-states')
  const available = isAvailableInState(included, state)

  // Region-unavailable cards keep the button enabled so it can still receive
  // hover (which reveals the "not available" note); the submit guard below
  // blocks the actual add. Sold-out stays truly disabled.
  card.classList.toggle(REGION_UNAVAILABLE_CLASS, !available)
  if (addBtn) addBtn.disabled = isSoldOut(addBtn)
}

function filterAllCards() {
  let state = null
  try {
    state = localStorage.getItem(REGION_LS_KEY)
  } catch {
    /* private mode */
  }
  document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
    applyCardAvailability(card, state)
  })
}

function init() {
  filterAllCards()

  document.addEventListener('theme:region:state-changed', filterAllCards)
  document.addEventListener('theme:cards:appended', filterAllCards)

  // Block add-to-cart for region-unavailable cards. Capture phase + immediate
  // stop runs before the global cart submit handler so the add never fires.
  document.addEventListener(
    'submit',
    (event) => {
      const card = event.target?.closest?.(CARD_SELECTOR)
      if (card?.classList.contains(REGION_UNAVAILABLE_CLASS)) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
    },
    true,
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
